import { useTranslation } from 'next-i18next'

const useSortOptions = () => {
  const { t } = useTranslation('listing')

  return [
    {
      label: t('ALL', { ns: 'common' }),
      value: '',
    },
    {
      label: t('PRICE_FROM_LOWEST'),
      value: 'price_asc',
    },
    {
      label: t('PRICE_FROM_HIGHEST'),
      value: 'price_desc',
    },
  ]
}

export default useSortOptions
